import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../utils/firebase'; // Make sure this points to your correct Firebase config file

const PrivateRoute = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        // Clean up subscription on unmount
        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div>Loading...</div>; // Show a loading message while Firebase checks the auth state
    }

    if (!user) {
        return <Navigate to="/auth/login" />; // Redirect to login if user is not authenticated
    }

    return children; // Render the protected content if the user is authenticated
};

export default PrivateRoute;